import { atom } from "recoil";

export const gametypeSaveAtom = atom<string>({
  key: "gametypeSaveAtom",
  default: "1",
});
